import React, { useContext, useState } from 'react'
import styles from '../BeneficiarioMultiple/BeneficiarioMultiple.module.css'
import Subtitle from '../Subtitle'
import Modal from '../Modals/Modal'
import * as Constantes from '../../utils/constantes'
//Context
import GeneralContext from '../../context/GeneralContext'

const BeneficiarioMultiple = ({ state, setState }) => {
    const { state: generalState } = useContext(GeneralContext)
    let user = generalState.users.filter((user) => user.isAuthenticated)[0]
    let prospecto = user.listaProspectos.filter(
        (prospecto) => prospecto.isSelected || prospecto.completado
    )[0]
    let cotizacion = prospecto.cotizaciones.filter(cotizacion => cotizacion.isSelected || cotizacion.completado)[0]

    const [mostrarModal, setMostrarModal] = useState(state.modalMultiple)
    const textos = [
        "Cambiar tipo de Beneficiario",
        "Al cambiar el tipo de beneficiario, deberás eliminar todos los beneficiarios ya guardados hasta el momento. ¿Estás seguro?"
    ]

    //Modo lectura
    let Deshabilitar = (complete) => {
        complete = cotizacion.edicionInhabilitada
        if (complete === true && complete !== undefined) {
            return true
        } else {
            return false
        }
    }

    const handleChangeBeneficiario = (e) => {
        let isValue = e.target.value === 'true' ? true : false
        if (state.beneficiarioMultiple === null) {
            setState((state) => {
                return {
                    ...state,
                    beneficiarioMultiple: isValue
                }
            })
        } else {
            if (state.tipoCaso === Constantes.TIPO_CASO_1) {
                if (state.beneficiarioMultiple) {
                    if (state.beneficiariosPrincipales.length > 0 || state.beneficiariosContingentes.length > 0) {
                        setMostrarModal(!mostrarModal)
                        setState((state) => {
                            return {
                                ...state,
                                modalMultiple: !mostrarModal,
                                multipleAux: isValue
                            }
                        })
                    } else {
                        setState((state) => {
                            return {
                                ...state,
                                beneficiarioMultiple: isValue
                            }
                        })
                    }
                } else {
                    if (state.beneficiariosUnicos.length > 0) {
                        setMostrarModal(!mostrarModal)
                        setState((state) => {
                            return {
                                ...state,
                                modalMultiple: !mostrarModal,
                                multipleAux: isValue
                            }
                        })
                    } else {
                        setState((state) => {
                            return {
                                ...state,
                                beneficiarioMultiple: isValue
                            }
                        })
                    }
                }
            } else if (state.tipoCaso === Constantes.TIPO_CASO_3) {
                if (state.beneficiarioMultiple) {
                    if (state.beneficiariosPrincipales.length > 0 || state.beneficiariosContingentes.length > 0) {
                        setMostrarModal(!mostrarModal)
                        setState((state) => {
                            return {
                                ...state,
                                modalMultiple: !mostrarModal,
                                multipleAux: isValue
                            }
                        })
                    } else {
                        setState((state) => {
                            return {
                                ...state,
                                beneficiarioMultiple: isValue
                            }
                        })
                    }
                } else {
                    if ((state.beneficiariosPrincipales.length > 0 || state.beneficiariosContingentes.length > 0)
                        || state.beneficiariosUnicos.length > 0) {
                        setMostrarModal(!mostrarModal)
                        setState((state) => {
                            return {
                                ...state,
                                modalMultiple: !mostrarModal,
                                multipleAux: isValue
                            }
                        })
                    } else {
                        setState((state) => {
                            return {
                                ...state,
                                beneficiarioMultiple: isValue
                            }
                        })
                    }
                }
            }
        }
    }

    const cambiarBeneficiario = async () => {
        setMostrarModal(!mostrarModal)
    }

    return (
        <React.Fragment>
            <Modal
                mostrarModal={mostrarModal}
                setModal={setMostrarModal}
                doble={true}
                textos={textos}
                accion={() => cambiarBeneficiario()}
            />
            <div className={styles.areadatosprospecto}>
                <Subtitle
                    sname="Beneficiarios"
                    smostrar={true}
                    sparrafo="Seleccionar tipo de beneficiario"
                />
                <div className={styles.optionlight}>
                    <label>
                        <input
                            type='radio'
                            value={true}
                            checked={state.beneficiarioMultiple === true}
                            selected={state.beneficiarioMultiple === true}
                            onChange={handleChangeBeneficiario}
                            disabled={Deshabilitar() !== true ? false : true}
                        />
                        <span className="span-radio-si-no">Beneficiario Múltiple</span>
                    </label>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <label>
                        <input
                            type='radio'
                            value={false}
                            checked={state.beneficiarioMultiple === false}
                            selected={state.beneficiarioMultiple === false}
                            onChange={handleChangeBeneficiario}
                            disabled={Deshabilitar() !== true ? false : true}
                        />
                        <span className="span-radio-si-no">Beneficiario Único</span>
                    </label>
                </div>
            </div>
        </React.Fragment>
    )
}

export default BeneficiarioMultiple